export const different_CreateContent = [
	{
		icon: '💃🏻',
		title: 'differentData.title1',
		subtitle: 'differentData.subtitle1',
	},
	{
		icon: '👩‍💻',
		title: 'differentData.title2',
		subtitle: 'differentData.subtitle2',
	},
	{
		icon: '👯‍♀️',
		title: 'differentData.title3',
		subtitle: 'differentData.subtitle3',
	},
	{
		icon: '🛍️',
		title: 'differentData.title4',
		subtitle: 'differentData.subtitle4',
	},
];
